import React from 'react';
import moment from 'moment';

const options = [];
let i;
let j;
let t;
let tText;
for (i = 0; i < 24; i += 1) {
    for (j = 0; j < 4; j += 1) {
        t = `${(`0${i}`).substr(-2, 2)}:${j === 0 ? '00' : j * 15}`;
        tText = `${i < 13 ? (`0${i === 0 ? 12 : i}`).substr(-2, 2) : (`0${i % 12}`).substr(-2, 2)}:${j === 0 ? '00' : j * 15}${i < 12 ? 'am' : 'pm'}`;
        options.push({ value: t, title: tText });
    }
}

const TimeSelect = props => {
    const { time, onChange, timeOptional } = props;
    let timeValue = '';
    timeValue = moment.isMoment(time) ? `${(`0${time.get('hour')}`).substr(-2, 2)}:${(`0${time.get('minute')}`).substr(-2, 2)}` : time;
    const myOptions = [...options];
    if (timeOptional) {
        myOptions.unshift({ value: 'unset', title: 'Follows previous match' });
    }

    console.log('TimeSelect timeValue', timeValue);
    return (
        <select
            className={`form-control time-select`}
            onChange={(e) => onChange(e.target.value)}
            value={timeValue}
        >
            <option value="">Time</option>
            {myOptions.map(option => <option value={option.value} key={option.value}>{option.title}</option>)}
        </select>
    );
};

export default TimeSelect;
